var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16665 5C9.16665 4.53976 9.53974 4.16667 9.99998 4.16667C10.4602 4.16667 10.8333 4.53976 10.8333 5V8.5563C11.3315 8.84448 11.6666 9.3831 11.6666 10C11.6666 10.9205 10.9205 11.6667 9.99998 11.6667C9.07951 11.6667 8.33331 10.9205 8.33331 10C8.33331 9.3831 8.66848 8.84448 9.16665 8.5563V5Z",
    fill: "#D80587"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 0C9.53974 0 9.16665 0.373096 9.16665 0.833333V0.870702C7.46389 1.02415 5.8954 1.64322 4.58947 2.59962L3.89879 1.90894C3.57335 1.5835 3.04528 1.58394 2.71984 1.90937C2.39441 2.23481 2.39397 2.76289 2.7194 3.08832L3.33633 3.70525C1.78467 5.34725 0.833313 7.56253 0.833313 10C0.833313 15.0626 4.93737 19.1667 9.99998 19.1667C15.0626 19.1667 19.1666 15.0626 19.1666 10C19.1666 7.56253 18.2153 5.34725 16.6636 3.70525L17.2806 3.08832C17.606 2.76289 17.6056 2.23481 17.2801 1.90937C16.9547 1.58394 16.4266 1.5835 16.1012 1.90894L15.4105 2.59962C14.1046 1.64322 12.5361 1.02415 10.8333 0.870702V0.833333C10.8333 0.373096 10.4602 0 9.99998 0ZM9.99998 17.4943C5.86099 17.4943 2.50567 14.139 2.50567 10C2.50567 5.86101 5.86099 2.50569 9.99998 2.50569C14.139 2.50569 17.4943 5.86101 17.4943 10C17.4943 14.139 14.139 17.4943 9.99998 17.4943Z",
    fill: "#D80587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.7521f27ff6da9c3a08238c8e0250604a.svg";
export { ForwardRef as ReactComponent };